import React from 'react';
import UDButton from 'modules/ud-ui/components/button';
import UDColorableIcon from 'modules/ud-ui/components/icon/colorable-icon';
import UDText from 'modules/ud-ui/components/text';
import { Organizer } from 'modules/organizer/domain/interfaces/Organizer';
import * as S from './styles';
import UDLink from '../../../link';
import { Pages } from '../../../../../navigation/domain/enums/pages';

type UDMenuLogoutProps = {
  isOrganizerLoading: boolean;
  organizerInfo: Organizer | null;
  onLogoutClick?: React.MouseEventHandler<HTMLElement>;
};

const UDMenuLogout = (props: UDMenuLogoutProps) => {
  if (props.isOrganizerLoading || !props.organizerInfo) {
    return (
      <S.MenuLogout className="d-flex flex-row flex-center align-items-start pl-10 pr-2">
        <UDButton
          variant="dark"
          className="logout d-flex align-items-center ml-auto"
          onClick={props.onLogoutClick}
        >
          <UDColorableIcon name="logout" />
        </UDButton>
      </S.MenuLogout>
    );
  }

  const logo = props.organizerInfo.logoUrl
    ? (<S.MenuLogo src={props.organizerInfo.logoUrl!} width={36} />)
    : null;

  return (
    <S.MenuLogout className="d-flex flex-row flex-center align-items-start pl-10 pr-2">
      <UDLink
        className="bold color-SurfaceWhite organizer-link"
        to={Pages.SELECT_TOURNAMENT}
      >
        {logo}
        <span>{props.organizerInfo.name}</span>
      </UDLink>

      <UDButton
        variant="dark"
        className="logout d-flex align-items-center ml-auto"
        onClick={props.onLogoutClick}
      >
        <UDColorableIcon name="logout" />
      </UDButton>
    </S.MenuLogout>
  );
};

export default UDMenuLogout;
